var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcTrash01Red({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "trash-01"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.33333 2.89152C5.33333 2.52333 5.63181 2.22485 6 2.22485H10C10.3682 2.22485 10.6667 2.52333 10.6667 2.89152C10.6667 3.25971 10.3682 3.55819 10 3.55819H6C5.63181 3.55819 5.33333 3.25971 5.33333 2.89152ZM2 5.00917C2 4.64098 2.29848 4.3425 2.66667 4.3425H13.3333C13.7015 4.3425 14 4.64098 14 5.00917C14 5.37736 13.7015 5.67583 13.3333 5.67583H12.6377C12.6386 5.70731 12.6385 5.73893 12.6372 5.77065L12.3333 13.4941C12.3259 14.5995 11.4684 15.5582 10.3333 15.5582H5.66667C4.53161 15.5582 3.67406 14.5995 3.66671 13.4941L3.36278 5.77065C3.36153 5.73893 3.36138 5.70731 3.36229 5.67583H2.66667C2.29848 5.67583 2 5.37736 2 5.00917ZM4.70644 5.67583C4.7011 5.68266 4.69423 5.69644 4.69509 5.71822L5 13.4666V13.4798C5 13.9277 5.33387 14.2249 5.66667 14.2249H10.3333C10.6661 14.2249 11 13.9277 11 13.4798V13.4666L11.3049 5.71822C11.3058 5.69644 11.2989 5.68266 11.2936 5.67583H4.70644ZM6.66667 7.16603C7.03486 7.16603 7.33333 7.46451 7.33333 7.8327V12.068C7.33333 12.4362 7.03486 12.7347 6.66667 12.7347C6.29848 12.7347 6 12.4362 6 12.068V7.8327C6 7.46451 6.29848 7.16603 6.66667 7.16603ZM9.33333 7.16603C9.70152 7.16603 10 7.46451 10 7.8327V12.068C10 12.4362 9.70152 12.7347 9.33333 12.7347C8.96514 12.7347 8.66667 12.4362 8.66667 12.068V7.8327C8.66667 7.46451 8.96514 7.16603 9.33333 7.16603Z",
    fill: "#E75858"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTrash01Red);
export default __webpack_public_path__ + "static/media/ic-trash-01-red.941ad1158a065801e00ae6dc17d914b8.svg";
export { ForwardRef as ReactComponent };